export default __webpack_public_path__ + "static/media/a014.f7f160d0.svg";